import { render, staticRenderFns } from "./NewsPaper.vue?vue&type=template&id=3a25710c&scoped=true"
import script from "./NewsPaper.vue?vue&type=script&lang=js"
export * from "./NewsPaper.vue?vue&type=script&lang=js"
import style0 from "./NewsPaper.vue?vue&type=style&index=0&id=3a25710c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a25710c",
  null
  
)

export default component.exports